import React from "react";
import { Animate } from "react-move";
import { ThemeConsumer } from "styled-components";

import { Opinion } from "@/service/Model";
import { easeBounceOut } from "@/utils/animation";

import {
  bucketWidth,
  centerPoint,
  isEnded,
  Result,
  spaceBetweenBucketsOffset,
  totalWidth,
} from "../MeterConstants";

export type MeterResultsProps = {
  answer?: number;
  results: Result[];
  meter: Opinion;
};

class MeterResults extends React.Component<MeterResultsProps, {}> {
  public render(): JSX.Element {
    const { answer, results, meter } = this.props;
    return (
      <ThemeConsumer>
        {(theme: any) => (
          <g>
            <rect
              x={0}
              y={centerPoint.y}
              width={totalWidth}
              height={2}
              fill={"#dedede"}
            />
            {(isEnded(meter) || answer !== undefined) &&
              results.map((result: Result, index: number) =>
                this.renderBars(result, theme, index)
              )}
          </g>
        )}
      </ThemeConsumer>
    );
  }

  public renderBars(result: any, theme: any, index: any): JSX.Element {
    return (
      <Animate
        key={index.toString()}
        start={{
          height: result.size,
          background:
            result.percent === 0
              ? theme.colors.borderGrey
              : theme.colors.primary,
          opacity: result.percent === 0 ? 0.75 : result.opacity,
          percent: result.percent,
        }}
        update={{
          height: [result.size],
          background: [
            result.percent === 0
              ? theme.colors.borderGrey
              : theme.colors.primary,
          ],
          opacity: [result.percent === 0 ? 0.75 : result.opacity],
          percent: [result.percent],
          timing: {
            duration: 300,
            ease: easeBounceOut,
          },
        }}
      >
        {(animation: {
          height: number;
          background: string;
          opacity: number;
          percent: number;
        }) => {
          return (
            <g
              transform={`translate(${result.bucket -
                bucketWidth / 2}, ${centerPoint.y - animation.height})`}
              key={index.toString()}
            >
              <text
                transform={`translate(${bucketWidth / 2}, -10)`}
                textAnchor="middle"
                className="meterResultText"
                fill="#000"
                height={40}
              >
                {Math.round(animation.percent)}%
              </text>
              <rect
                x={spaceBetweenBucketsOffset / 2}
                y={0}
                width={bucketWidth - spaceBetweenBucketsOffset}
                height={animation.height}
                fill={animation.background}
                style={{ opacity: animation.opacity }}
              />
            </g>
          );
        }}
      </Animate>
    );
  }
}

export default MeterResults;
